var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMuteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.708 2.47161V20.1516C15.708 21.7496 13.804 22.5996 12.614 21.5116L6.698 16.1396H1.836C0.816 16.1396 0 15.3236 0 14.3036V8.31961C0 7.29961 0.816 6.48361 1.836 6.48361H6.698L12.648 1.11161C13.838 0.023613 15.708 0.873613 15.708 2.47161Z",
    fill: "#603004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 14.5754C26.7241 13.3174 25.9761 12.5694 24.7181 11.3114C25.9761 10.0534 26.7241 9.30545 27.9821 8.04745C28.6961 7.33345 27.5741 6.21145 26.8601 6.92545C25.6021 8.18345 24.8541 8.93145 23.5961 10.1894C22.3381 8.93145 21.5901 8.18345 20.3321 6.92545C19.6181 6.21145 18.4961 7.33345 19.2101 8.04745C20.4681 9.30545 21.2161 10.0534 22.4741 11.3114C21.2161 12.5694 20.4681 13.3174 19.2101 14.5754C18.4961 15.2894 19.6181 16.4114 20.3321 15.6974C21.5901 14.4394 22.3381 13.6914 23.5961 12.4334C24.8541 13.6914 25.6021 14.4394 26.8601 15.6974C27.5741 16.4114 28.6961 15.2894 27.9821 14.5754Z",
    fill: "#603004"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMuteIcon);
export default __webpack_public_path__ + "static/media/volumeMuteIcon.57b156c46fa187ca5d4333ee3b8156f8.svg";
export { ForwardRef as ReactComponent };